import { createFileRoute } from '@tanstack/react-router';

import { ContactPage } from '@/features/marketing/pages/contact';

export const Route = createFileRoute('/contact')({ component: ContactPage });
